import * as React from 'react';
import Icon from './Icon';
import * as topIllustrationSimple from '../assets/images/top-illustration-simple.svg';
import * as shield from '../assets/images/icon-shield.svg';
import * as hourglass from '../assets/images/icon-hourglass.svg';
import * as paperPlane from '../assets/images/icon-paperplane.svg';
import { t } from '../helper/locale';

export const GenericBlocker: React.FunctionComponent<{
  params: { reason: string };
}> = ({ params }) => {
  const texts = getBlockerTexts(params.reason);
  return (
    <div className="Blocker">
      <div className="illustrations-wrapper">
        <img className="top-illustration-simple" src={topIllustrationSimple} />
        <Icon
          className="top-illustration"
          path={getBlockerIcon(params.reason)}
        />
      </div>

      <h1>{texts.title}</h1>

      <p className="Blocker__text"> {texts.text} </p>
    </div>
  );
};

const texts = {
  generic: {
    title: t('For your safety this page has been blocked'),
    text: t(
      'Qustodio constantly works to improve your online safety and therefore we have prevented access to this page.'
    ),
  },
  'page-not-allowed': {
    title: t('For your safety this page has been blocked'),
    text: t(
      'Qustodio constantly works to improve your online safety and therefore we have prevented access to this page.'
    ),
  },
  'quota-exceeded': {
    title: t('Your internet allowance is over'),
    text: t("Today's internet allowance has finished. Come back another day!"),
  },
  'time-restricted': {
    title: t('Browsing blocked'),
    text: t('You are outside your allowed time schedule. Come back later.'),
  },
} as const;

const getBlockerTexts = (key: keyof typeof texts | string) => {
  if (!(key in texts)) {
    return texts.generic;
  }

  return texts[key as keyof typeof texts];
};

const icons = {
  generic: shield,
  'page-not-allowed': shield,
  'quota-exceeded': hourglass,
  'time-restricted': paperPlane,
} as const;

const getBlockerIcon = (key: keyof typeof icons | string) => {
  if (!(key in icons)) {
    return icons.generic;
  }

  return icons[key as keyof typeof icons];
};
